import { Container, DropdownMenu } from 'reactstrap';
import { darkShadow, sanJuan } from 'components/style/Colors.style';
import BreakPoints from 'components/style/Breakpoints.style';
import styled from 'styled-components';

export const AppContainer = styled(Container)`
  color: ${sanJuan};
  @media (max-width: ${BreakPoints.lg}) {
    width: 100%;
    max-width: none;
  }
`;

export const PageContainer = styled(Container).attrs({
  fluid: true,
  className: 'py-3 px-lg-0'
})`
  min-height: 700px;
  @media (max-width: ${BreakPoints.lg}) {
    width: 100%;
    max-width: none;
  }
`;

export const SuggestMenu = styled(DropdownMenu)`
  box-shadow: 0 24px 32px 0 ${darkShadow};

  & > .react-autosuggest__suggestions-list {
    list-style: none;
    padding: 0 1rem;
    min-height: 15.625rem;
    min-width: 18.75rem;
    margin: 0;
  }
`;

export const PageContainerGeneric = styled(PageContainer)`
  & h1 {
    font-size: 1.75rem;
    margin: 16px 0;
  }
  & h2 {
    font-size: 1.25rem;
    margin: 32px 0 16px 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/style/Containers.style.js